// Kompresja/zmniejszanie zdjęć w przeglądarce przed wysyłką — oszczędza transfer
// monterom w terenie (słaby zasięg). Zwraca File (JPEG). Przy błędzie oddaje oryginał.
export async function compressImage(file, maxDim = 1600, quality = 0.72) {
  try {
    if (!file || !file.type || !file.type.startsWith("image/") || file.type === "image/gif") return file;
    const dataUrl = await new Promise((res, rej) => {
      const fr = new FileReader();
      fr.onload = () => res(fr.result);
      fr.onerror = rej;
      fr.readAsDataURL(file);
    });
    const img = await new Promise((res, rej) => {
      const im = new Image();
      im.onload = () => res(im);
      im.onerror = rej;
      im.src = dataUrl;
    });
    let { width, height } = img;
    if (width <= maxDim && height <= maxDim && file.size < 600 * 1024) return file;
    const scale = Math.min(1, maxDim / Math.max(width, height));
    width = Math.round(width * scale);
    height = Math.round(height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, width, height);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
    if (!blob || blob.size >= file.size) return file;
    const name = (file.name || "zdjecie").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg", lastModified: Date.now() });
  } catch {
    return file;
  }
}
